import { Fetch } from "../utils/fetch";
/**
 * Sample操作封装
 */
export class CompanyManageApi {
  /**
   * 保存数据
   * @param {SampleForm} data 保存数据对象
   */
  getGroceryByPage(data) {
    return Fetch.fetch({
      url: "Grocery/GetGroceryByPage",
      method: "get",
      params: data
    });
  }

  insertGrocery(data) {
    return Fetch.fetch({
      url: "Grocery/InsertGrocery",
      method: "post",
      data: data
    });
  }
  updateGrocery(data) {
    return Fetch.fetch({
      url: "Grocery/UpdateGrocery",
      method: "put",
      data: data
    });
  }
  deleteGrocery(data) {
    return Fetch.fetch({
      url: "Grocery/DeleteGrocery",
      method: "delete",
      params: data
    });
  }
}
